import { render, staticRenderFns } from "./vehiclePollution.vue?vue&type=template&id=0f98ba54"
import script from "./vehiclePollution.vue?vue&type=script&lang=js"
export * from "./vehiclePollution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports